export const PILLARS = [
  { id: "asset", name: "Asset", desc: "Immobili, B&B, barche, ristrutturazioni", badge: "bg-amber-100 text-amber-900 border border-amber-300" },
  { id: "experience", name: "Experience", desc: "Eventi, party, turismo, ospitalità", badge: "bg-purple-100 text-purple-900 border border-purple-300" },
  { id: "digital", name: "Digital", desc: "Branding, design, social, siti web", badge: "bg-blue-100 text-blue-900 border border-blue-300" },
  { id: "professions", name: "Professions", desc: "Vendita, marketing, affiliazione", badge: "bg-emerald-100 text-emerald-900 border border-emerald-300" },
];

export function pillarOf(id) {
  return PILLARS.find((p) => p.id === id);
}

export function PillarBadge({ id, className = "" }) {
  const p = pillarOf(id);
  if (!p) return null;
  return (
    <span data-testid={`pillar-badge-${id}`} className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-medium ${p.badge} ${className}`}>
      {p.name}
    </span>
  );
}

export function GoldBadge({ className = "" }) {
  return (
    <span data-testid="gold-badge" className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold bg-gradient-to-r from-amber-400 via-yellow-300 to-amber-500 text-black border border-amber-400/50 ${className}`}>
      Oro
    </span>
  );
}
